import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiUsers} = FiIcons;

export default function SkoolBanner() {
  return (
    <div className="mt-8 flex flex-col items-start justify-between gap-5 rounded-3xl bg-[#f8b86a] p-6 text-[#0b1423] sm:flex-row sm:items-center sm:p-8">
      <div className="flex items-start gap-4">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#0b1423]">
          <SafeIcon icon={FiUsers} className="h-6 w-6 text-white" />
        </span>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em]">Community</p>
          <h2 className="mt-1 text-xl font-black leading-tight sm:text-2xl">Join our Skool community.</h2>
          <p className="mt-1 text-sm leading-relaxed sm:text-base">Get support, share wins and learn alongside other Jelly Local users.</p>
          <a
            href="https://www.skool.com/the-jelly-pay-squad-6985"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center rounded-full bg-[#0b1423] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#26354a]"
          >
            Join the Skool group
          </a>
        </div>
      </div>
    </div>
  );
}